import { CaseType } from "@/api/rest/models/warranty";

export const caseTypeNamespaceMap = new Map<CaseType, string>([
  [CaseType.WARRANTY, "warranty"],
  [CaseType.PROPERTY_MANAGER_CASE, "propertyManagerCase"],
]);
